import React from "react";
import { getStatusColor } from "../HotelPage/utils/hotelUtils";

// Mapping des statuts de features vers les statuts de modules pour réutiliser les mêmes couleurs
const getFeatureStatusColor = (status) => {
  const statusMap = {
    LIVE: "Good",
    PAS_EQUIPE: "À équiper",
    DESEQUIPE: "Warning",
    OFF: "Failed",
  };
  return getStatusColor(statusMap[status] || status);
};

const getFeatureStatusLabel = (status) => {
  switch (status) {
    case "LIVE":
      return "LIVE";
    case "PAS_EQUIPE":
      return "Pas équipé";
    case "DESEQUIPE":
      return "Déséquipé";
    case "OFF":
      return "OFF";
    default:
      return "Non défini";
  }
};

const FeatureStatusBadge = ({ status }) => {
  const displayStatus = status || null;
  
  return (
    <span
      className={`
        inline-flex items-center px-2 py-0.5 rounded text-xs font-medium
        ${getFeatureStatusColor(displayStatus)}
      `}
    >
      {getFeatureStatusLabel(displayStatus)}
    </span>
  );
};

export default FeatureStatusBadge;
